import { isEqual } from "lodash";
import { useState } from "react";

import { INCOMING_MAIL_STATUSES, MAIL_CLASSIFICATION_STATUS } from "src/utils/constants/constants";
import { IncomingMailCombinedStatusQuickFilter } from "./interfaces";

export const useIncomingMailCombinedStatusQuickFilter = () => {
  const [quickFilter, setQuickFilter] = useState<IncomingMailCombinedStatusQuickFilter>({
    incomingMailCombinedStatus: {
      statusIds: [INCOMING_MAIL_STATUSES.Pending.id, MAIL_CLASSIFICATION_STATUS.ToBeClassified.id],
    },
  });

  const handleChangeQuickFilter = (
    filter: keyof IncomingMailCombinedStatusQuickFilter,
    value: IncomingMailCombinedStatusQuickFilter["incomingMailCombinedStatus"]
  ) => {
    if (isEqual(value, quickFilter[filter])) return;

    setQuickFilter((state) => ({ ...state, [filter]: value }));
  };

  return {
    incomingMailCombinedStatusQuickFilter: quickFilter,
    setIncomingMailCombinedStatusQuickFilter: handleChangeQuickFilter,
  };
};
